<form class="signUp" [formGroup]="signUpForm" autocomplete="off">
    <div class="container-fluid signUpContainer mt-3">
        <div class="col-md-12">
       
            <div class="col-md-12 d-flex">
               
                <div class="card sgUpFrmCard">
                 <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="companyname" class="form-labe mandatoryLabel">Company Name <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                <div class="input-field">
                                    <input formControlName="companyname" id="companyname" TrimText name="companyname"
                                        class="form-control" type="text" placeholder="Enter company name">
                                </div>
                                <span class="text-danger"
                                    *ngIf="f['companyname'].touched && f['companyname'].hasError('required')">
                                    Company name is required.
                                </span>
                                <span class="text-danger"
                                *ngIf="f['companyname'].touched && f['companyname'].hasError('pattern')">
                                Enter valid company name.
                            </span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="location" class="form-label mandatoryLabel">Company Location <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                <div class="input-field">
                                    <input formControlName="location" id="location" name="location" TrimText class="form-control"
                                        type="text" placeholder="Enter company location">
                                </div>
                                <span class="text-danger"
                                    *ngIf="f['location'].touched && f['location'].hasError('required')">
                                    Company location is required.
                                </span>
                                <span class="text-danger"
                                *ngIf=" f['location'].touched && f['location'].hasError('pattern')">
                                Enter valid location.
                            </span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="username" class="form-label mandatoryLabel">User Name <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                <div class="input-field">
                                    <input formControlName="username" id="username" TrimText name="username" class="form-control"
                                        type="text" placeholder="Enter user name" autocomplete="off">
                                </div>
                                <span class="text-danger"
                                    *ngIf="f['username'].touched && f['username'].hasError('required')">
                                    User name is required.
                                </span>
                                <span class="text-danger"
                                *ngIf="f['username'].touched && f['username'].hasError('pattern')">
                                Enter valid username.
                            </span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="transcribe" class="form-label mandatoryLabel">Transcribe <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                <!-- <ng-select placeholder="choose/search" dropdownPosition="auto"
                                    formControlName="transcribe" name="transcribe" id="transcribe"
                                    class="transcribeClass">
                                    <ng-option value="1">AWS</ng-option>
                                    <ng-option value="2">Google</ng-option>
                                </ng-select> -->
                                <ng-select  placeholder="Choose/search" formControlName="transcribe" name="transcribe" id="transcribe"
                                class="transcribeClass">
                                    @for (transcribe of transcribeList; track transcribe.id) {
                                        <ng-option [value]="transcribe.id">{{transcribe.name}}</ng-option>
                                    }
                                </ng-select>
                                <span class="text-danger"
                                    *ngIf="f['transcribe'].touched && f['transcribe'].hasError('required')">
                                    Transcribe is required.
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="email" class="form-label mandatoryLabel"
                                    [ngClass]="{ 'is-invalid': submitted && f['email'].errors }">Email <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                <div class="input-field">
                                    <input formControlName="email" id="email" TrimText name="email" class="form-control"
                                        type="email" placeholder="user@example.com" autocomplete="off">
                                </div>
                                 <span class="text-danger"
                                    *ngIf="f['email'].touched && f['email'].hasError('required')">
                                    Email is required.
                                </span>
                                <span class="text-danger"
                                *ngIf="f['email'].touched && f['email'].hasError('pattern')">
                                Enter valid email.
                               </span>
                                <!-- <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                                    <div class="text-danger" *ngIf="submitted || f['email'].touched && f['email'].errors['required']">
                                        Email is required</div>
                                    <div class="text-danger" *ngIf="f['email'].errors['pattern']">Email is not Valid
                                    </div>
                                </div> -->

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="password" class="form-label mandatoryLabel"
                                    [ngClass]="{ 'is-invalid': submitted && f['password'].errors }">Password <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                <div class="input-field">
                                    <input formControlName="password" id="password" TrimText name="password" class="form-control"
                                        [type]="type" placeholder="Enter password" autocomplete="off" >
                            
                                    <span style="position: relative;">
                                        <span class="fa {{eyeIcon}} passwordEye" (click)="hideShowPassword()"></span>
                                      </span>
                                </div>
                                 <span class="text-danger"
                                    *ngIf="f['password'].touched && f['password'].hasError('required')">
                                    Password is required.
                                </span>
                                 <div class="text-danger" *ngIf="f['password'].touched && f['password'].hasError('minlength')">
                                        Password must be at least 8 characters
                                    </div>
                                <span class="text-danger"
                                *ngIf="f['password'].touched && f['password'].invalid && f['password'].hasError('pattern')">
                                 Password must be at least 8 characters, and include at least 1 number and 1 special character( _, &#64;,  or $).
                               </span>
                                <!-- <div *ngIf="submitted && f['password'].errors" class="invalid-feedback">
                                    <div class="text-danger"
                                        *ngIf="f['password'].errors['required'] && f['password'].invalid">
                                        Password is required</div>
                                    <div class="text-danger" *ngIf="f['password'].errors['minlength']">
                                        Password must be at least 8 characters
                                    </div>
                                    <div class="text-danger" *ngIf="f['password'].errors['pattern']">Password must
                                        contain a number and At least 1 character from[ _ or &#64; or $ ].</div>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-md-6 lastTwoInput">
                            <div class="form-group">
                                <label for="phonenumber" class="form-label mandatoryLabel"
                                    [ngClass]="{ 'is-invalid': submitted && f['phonenumber'].errors }">Phone Number
                                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                <div class="input-field">
                                    <!-- <input formControlName="phonenumber" id="phonenumber" name="phonenumber"
                                        class="form-control" ng2TelInput type="tel"
                                        [ng2TelInputOptions]="{initialCountry: 'in'}" (hasError)="hasError($event)"
                                        (ng2TelOutput)="getNumber($event)" (intlTelInputObject)="telInputObject($event)"
                                        (countryChange)="onCountryChange($event)" placeholder="Enter phone number"> -->
                                        <input formControlName="phonenumber" id="phonenumber" TrimText (input)="onInputPhoneChange($event)" name="phonenumber"
                                        class="form-control"  #intlInput type="tel"
                                         placeholder="Enter phone number">
                                </div>
                                
                                    <div class="text-danger" *ngIf="f['phonenumber'].touched && f['phonenumber'].hasError('required')">
                                        Phone number is required</div>
                                    <div class="text-danger" *ngIf="f['phonenumber'].touched && f['phonenumber'].hasError('pattern') || f['phonenumber'].hasError('maxlength')">Phone number
                                        is
                                        not Valid and must contain atleast 10 numbers</div>
                                 
                            </div>
                        </div>
                        <div class="col-md-6 lastTwoInput">
                            <div class="form-group">
                                <label for="agent" class="form-label mandatoryLabel">File Upload Per Agent</label>
                                <div class="input-field">
                                    <input formControlName="agent" id="agent" name="agent" class="form-control"
                                        type="number" onkeydown="return event.keyCode !== 69"
                                        placeholder="Enter number">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-check">
                                <input class="form-check-input" formControlName="terms"
                                    [ngClass]="{ 'is-invalid': submitted && f['terms'].errors }" type="checkbox"
                                    id="flexCheckDefault">
                                <label class="form-check-label" for="flexCheckDefault">
                                    I"ve read and agree to the canstring ai <a href="https://canstring.ai/terms-of-use" target="_blank">term of use</a> and <a href="https://canstring.ai/privacy-policy" target="_blank">privacy policy</a>
                                </label>
                                <div *ngIf="submitted && f['terms'].errors" class="invalid-feedback">
                                    <div class="text-danger" *ngIf="f['terms'].errors['terms']">
                                        Agree terms and policy</div>
                                    <div class="text-danger" *ngIf="f['terms'].errors['requiredTrue']">Phone number
                                        is
                                        not Valid and must contain atleast 10 numbers</div>

                                </div>
                            </div>
                        </div>
                        <div class="col-md-10 offset-md-1">
                            <button class="btn btn-primary signInBtn" [disabled]="spinner" (click)="onSubmit()"> <i
                                    class="fa fa-spinner fa-pulse fa-3x fa-fw fa-spinner-login" *ngIf="spinner">
                                    <span class="sr-only">Loading...</span>
                                </i>
                                Sign Up</button>
                            <p class="ReturnLoginTxt" (click)="returnBack('login')"><a>Return to Log in</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
